import {
  GET_TAI_SAN_THEO_CHO_VAY,
  GET_TAI_SAN_THEO_CHO_VAY_SUCCESS,
  GET_TAI_SAN_THEO_CHO_VAY_FAILURE,
  GET_TAI_SAN,
  GET_TAI_SAN_SUCCESS,
  GET_TAI_SAN_FAILURE,
  GET_LICH_SU_TAI_SAN,
  GET_LICH_SU_TAI_SAN_SUCCESS,
  GET_LICH_SU_TAI_SAN_FAILURE,
} from "actions/TaiSan/actionTypes";

const initialState = {
  taiSanTheoChoVayLoaded: false,
  taiSanTheoChoVay: [],
  choVayIdLoaded: 0,
  taiSan: {},
  getTaiSanLoading: false,
  LichSuTaiSan: {
    List: [],
    totalRow: 0,
  },
  getLichSuTaiSanLoading: false,
  modalTSDetail: false,
};

const getTaiSanTheoChoVay = (state, action) => ({
  ...state,
  getTaiSanTheoChoVayLoading: true,
  taiSanTheoChoVayLoaded: true,
  choVayIdLoaded: action.ChoVayId,
});

const getTaiSanTheoChoVaySuccess = (state, action) => {
  return {
    ...state,
    getTaiSanTheoChoVayLoading: false,
    taiSanTheoChoVayLoaded: true,
    taiSanTheoChoVay: action.payload,
  };
};

const getTaiSanTheoChoVayFailed = (state, action) => ({
  ...state,
  getTaiSanTheoChoVayLoading: false,
  taiSanTheoChoVay: [],
  taiSanTheoChoVayLoaded: true,
});
const getTaiSan = (state, action) => ({
  ...state,
  getTaiSanLoading: true,
});

const getTaiSanSuccess = (state, action) => {
  return {
    ...state,
    getTaiSanLoading: false,
    taiSan: action.payload,
  };
};

const getTaiSanFailed = (state, action) => ({
  ...state,
  getTaiSanLoading: false,
  taiSan: {},
});
const getLichSuTaiSan = (state, action) => ({
  ...state,
  getLichSuTaiSanLoading: true,
});

const getLichSuTaiSanSuccess = (state, action) => {
  return {
    ...state,
    getLichSuTaiSanLoading: false,
    LichSuTaiSan: action.payload,
  };
};

const getLichSuTaiSanFailed = (state, action) => ({
  ...state,
  getLichSuTaiSanLoading: false,
  LichSuTaiSan: {
    List: [],
    totalRow: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TAI_SAN_THEO_CHO_VAY:
      return getTaiSanTheoChoVay(state, action);
    case GET_TAI_SAN_THEO_CHO_VAY_SUCCESS:
      return getTaiSanTheoChoVaySuccess(state, action);
    case GET_TAI_SAN_THEO_CHO_VAY_FAILURE:
      return getTaiSanTheoChoVayFailed(state, action);
    case GET_TAI_SAN:
      return getTaiSan(state, action);
    case GET_TAI_SAN_SUCCESS:
      return getTaiSanSuccess(state, action);
    case GET_TAI_SAN_FAILURE:
      return getTaiSanFailed(state, action);
    case GET_LICH_SU_TAI_SAN:
      return getLichSuTaiSan(state, action);
    case GET_LICH_SU_TAI_SAN_SUCCESS:
      return getLichSuTaiSanSuccess(state, action);
    case GET_LICH_SU_TAI_SAN_FAILURE:
      return getLichSuTaiSanFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
